import { GETRECENTCLIENTORDERLIST_TYPES } from '../actions/getRecentClientOrderList'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETRECENTCLIENTORDERLIST_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
